import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import QuoteOpenBook from "../../assets/icons/quoteOpenBook";
import {
  addStoryRoute,
  homeRoute,
  privateRoutes,
  signinRoute,
  storiesRoute,
} from "../../routes/routesPath";
import useAuth from "../../hooks/useAuth";
import { getMyAccountPagePath, getUserImage, handleLoginPop } from "../../utils/helpers";
import MyAccount from "../sidebars/myAccount";
import useWindowDimensions from "../../hooks/useWindowDimensions";
import { manageQuoteModal } from "../../redux/common/slice";

export default function Header() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { isAuthenticated } = useAuth();
  const { width = 0 } = useWindowDimensions();
  const { userProfile = {} } = useSelector((state) => state.auth || {});

  const [userAction, setUserAction] = useState({});

  const handleShowQuote = () => {
    dispatch(manageQuoteModal(true));
  };

  return (
    <>
      <header className="headerContainer px-3">
        <div className="header">
          <Link to={homeRoute} className="navbar-brand">
            <div className="d-flex align-items-center">
              <img className="mainLogo img-fluid" src={"/appLogo.png"} alt="logo" />
            </div>
          </Link>

          <div className="d-flex align-items-center">
            <div className="d-sm-flex align-items-center">
              <div className="d-none d-sm-block">
                <Link className="headerLink text-decoration-none d-inline-block" to={storiesRoute}>
                  Stories
                </Link>
                {isAuthenticated ? (
                  <Link
                    className="headerLink text-decoration-none d-inline-block"
                    to={privateRoutes.chatRoute}>
                    Messages
                  </Link>
                ) : (
                  <button className="textBtn headerLink" onClick={() => handleLoginPop(true)}>
                    Messages
                  </button>
                )}
              </div>
              <Link
                className="primaryBtn rounded-pill py-1 px-2 mx-2 text-decoration-none d-none d-sm-inline-block"
                to={isAuthenticated ? addStoryRoute : signinRoute}>
                Share your feelings
              </Link>
              <QuoteOpenBook className="headerIcon pointer" onClick={handleShowQuote} />
              {/* <img
                src={"/images/quoteOpenBook.webp"}
                alt={"Feelinghub daily quote"}
                className="headerIcon pointer img-fluid object-fit-cover"
                onClick={handleShowQuote}
              /> */}
              {isAuthenticated ? (
                <>
                  <img
                    src={getUserImage(userProfile)}
                    alt={userProfile?.name}
                    onError={(e) => {
                      e.target.src = getUserImage();
                    }}
                    className="headerIcon pointer img-fluid object-fit-cover mx-2 d-none d-sm-inline-block"
                    onClick={() => {
                      if (width >= 992) {
                        navigate(getMyAccountPagePath());
                      } else {
                        setUserAction({ action: "showMyAccountOptions" });
                      }
                    }}
                  />
                </>
              ) : (
                <Link
                  to={signinRoute}
                  className="border border-2 border-secondary bg-secondary text-white rounded-pill py-1 px-3 ms-2 text-decoration-none">
                  Login
                </Link>
              )}
            </div>
          </div>
        </div>
      </header>
      <MyAccount userAction={userAction} setUserAction={setUserAction} />
    </>
  );
}
